module.exports = "/assets/25193a612175bcb54dc159aa9f73656a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/KM.png
// module id = 2674
// module chunks = 0